import React from 'react';
import styled from 'styled-components';

import messages from './messages';

import { FrownOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
// import { useRouteError } from 'react-router';

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;

    & > div:first-child {
        margin-right: 15px;
    }
`;

const GenericPageError = () => (
    // const error = useRouteError();
    <Container>
        <div>
            <FrownOutlined
                style={{
                    color: 'red',
                    verticalAlign: 'text-bottom',
                }}
            />
        </div>
        <div>
            <FormattedMessage {...messages.errorMessage} />
        </div>
    </Container>
);
export default GenericPageError;
